import Janet from './Janet';
import { createShadowDom } from './createShadowDom';

const root = createShadowDom();
root.render(<Janet />);